const initialState = {
    adminId: '',
    accessToken: '',
    countries: [
        {
            countryId: 1,
            countryName: "India",
            countryCode: "+91",
        }

    ],
    totalCounts: {
        users: 0,
        chefsAndResturants: 0,
        chefs: 0,
        resturants: 0,
        orders: 0,
        activeOrders: 0,
        inDeliveryOrders: 0,
        finishedOrders: 0,
        payments: 0,
    }
}

export default function loginReducer(state = initialState, action) {
    switch (action.type) {
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                adminId: action.payload.adminId,
                accessToken: action.payload.accessToken
            }
        case 'LOAD_COUNTRIES':
            return {
                ...state,
                countries: action.payload.countries
            }
        case 'TOTAL_COUNTS':
            return {
                ...state,
                totalCounts: {
                    ...state.totalCounts,
                    ...action.payload
                }
            }
        default:
            return state
    }
}
